import { IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import StandardAutoComplete from "./standard.autocomplete";

interface IGenericAutoComplete extends IStandardAutocomplete {
    itemsLoader: (parentId?: number | string) => Promise<any>;
}

export const GenericAutoComplete = (params: IGenericAutoComplete) => {


    return (

        <StandardAutoComplete
            {...params}
            itemsLoader={() => params.itemsLoader(params.parentId)}
            label={params.label || ""} />
    );
}